import { render } from "./PAddAvatar.vue?vue&type=template&id=ff433ba6"
import script from "./PAddAvatar.vue?vue&type=script&lang=js"
export * from "./PAddAvatar.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__